import { useQuery } from '@apollo/client';

import { USERS } from '../graphql/query/usersQuery.graphql';

export const useUsersQuery = () => {
  return useQuery(USERS);
};
